import { Component, OnInit, Input } from "@angular/core";
import { BaseService } from "../base.service";
import { environment } from "./../../../environments/environment";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
@Component({
  selector: "app-language-grid",
  templateUrl: "./language-grid.component.html",
  styleUrls: ["./language-grid.component.css"],
})
export class LanguageGridComponent implements OnInit {
  @Input() isSearch: any;
  languageData: any;
  shimmerStatus: any = { language: true };
  constructor(
    private pagesService: BaseService,
    public translate: TranslateService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.getLanguage();
  }

  getLanguage() {
    if (
      localStorage.getItem(environment.pagesLocalStorageKey) &&
      JSON.parse(localStorage.getItem(environment.pagesLocalStorageKey))
        .map((el) => {
          return el.hasOwnProperty("languages");
        })
        .indexOf(true) != -1
    ) {
      const localdata = JSON.parse(localStorage.getItem(environment.pagesLocalStorageKey));

      const index = localdata
        .map((el) => {
          return el.hasOwnProperty("languages");
        })
        .indexOf(true);

      this.languageData = localdata[index]["languages"].results;

      this.shimmerStatus.language = false;
    } else {
      this.pagesService.genereLanguage().subscribe(
        (res) => {
          this.languageData = res.results;
          this.shimmerStatus.language = false;
          if (!localStorage.getItem(environment.pagesLocalStorageKey)) {
            const localdata = [{ ["languages"]: res }];
            localStorage.setItem(environment.pagesLocalStorageKey, JSON.stringify(localdata));
          } else {
            const localdata = JSON.parse(localStorage.getItem(environment.pagesLocalStorageKey));
            localdata.push({ ["languages"]: res });
            localStorage.setItem(environment.pagesLocalStorageKey, JSON.stringify(localdata));
          }
        },
        (err) => {
          if (err.status === 0) {
            this.toastr.error("CONNECTION REFUSED", "Whoops!", {
              closeButton: true,
            });
          } else if (err.status === 500) {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          } else if (err.status === 404) {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          } else if (err.status === 401) {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          } else {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          }
        }
      );
    }
  }
}
